import HttpClient from "./httpClient";

class DocApi extends HttpClient {
  public getDocs = (customerId?: string) =>
    this.get(
      "/docs",
      {},
      customerId && customerId !== "all" ? { customerId } : {}
    );

  public getDocById = (id: string | number) => this.get(`/docs/${id}`, {});

  public addDoc = (doc: any) => this.post("/docs", {}, doc);

  public updateDoc = (doc: any) =>
    this.put(`/docs/${doc.id}`, {}, doc);

  public deleteDoc = (id: string | number) =>
    this.del(`/docs/${id}`, {});

  public getReindexStatus = (sourceDocType: "guide" | "kb" | "hudu_articles" | "itglue_docs" = "kb") =>
    this.get("/reindex/status", {}, { source_doc_type: sourceDocType });

  public triggerReindex = (sourceDocType: "guide" | "kb" | "hudu_articles" | "itglue_docs" = "kb") =>
    this.post("/reindex/trigger", {}, { source_doc_type: sourceDocType });
}

export default DocApi;

